module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "author"
  }, [_vm._v("1")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_c('span', [_vm._v("Du machtest")]), _vm._v(" mich endlos\n– so"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nist dein Belieben. Dies schwache Gefäß"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nleertest du wieder und wieder und"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nfülltest es immer mit neuem Leben.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Du trugst diese kleine Rohrflöte über"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nHügel und Täler und hauchtest durch sie"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\newig neue Melodien.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Bei dem unsterblichen Druck deiner"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nHände verliert mein kleines Herz seine"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nGrenze in Freude und gebiert unaussprechliche"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nWorte.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Deine unendlichen Gaben empfange"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nich nur auf diesen meinen sehr kleinen"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nHänden. Zeitalter vergehn und immer"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\ngießest du aus, und immer ist Raum, um"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nerfüllt zu werden. "), _c('a', {
    attrs: {
      "id": "page4",
      "title": "JohannN/wedi"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a637da12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0002.vue
// module id = 60
// module chunks = 0